
const _stockInIdDateTime = Symbol();
const _invoiceDetailId = Symbol();
const _tankId = Symbol();
const _productId = Symbol();
const _quantity = Symbol();
const _shiftId = Symbol();
const _stockInId = Symbol();
const _remaining = Symbol();
const _startDip = Symbol();
const _endDip = Symbol();
const _afterReading = Symbol();
const _beforeReding = Symbol();
const _shiftDate = Symbol();
const _endDipVolume = Symbol();
const _startDipVolume = Symbol();
const _errs = Symbol();
class StockIn {
    constructor({ remaining, stockInDateTime, invoiceDetailId, tankId, quantity, shiftId, productId, stockInId, startDip, endDip, startDipVolume, endDipVolume, beforeReading, afterReading, shiftDate }) {
        this[_errs] = {};
        Object.defineProperties(this, {
            remaining: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseInt(value, 10);
                    if (x) {
                        this[_remaining] = x;
                        delete this[_errs].remaining;
                    } else {
                        this[_errs].remaining = "remaining must be a valid integer";
                    }

                },
                get: function () {
                    return this[_remaining];
                }
            },
            shiftDate: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    const pattern = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;
                    if (pattern.test(value) && Date.parse(value)) {
                        this[_shiftDate] = value || null;
                        delete this[_errs].shiftDate;
                    } else {
                        this[_errs].shiftDate = "please enter a valid date YYYY-MM-DD format";
                    }
                },
                get: function () {
                    return this[_shiftDate];
                }
            },
            stockInDateTime: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    //2018-02-24 23:22
                    const dateTime = /^([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2})$/;
                    if (dateTime.test(value) && Date.parse(value)) {

                        this[_stockInIdDateTime] = value;
                        delete this[_errs].stockInDateTime;

                    } else {
                        this[_errs].stockInDateTime = "please enter a valid StockIn  date & time";
                    }

                },
                get: function () {
                    return this[_stockInIdDateTime];
                }
            },
            invoiceDetailId: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseInt(value, 10);
                    if (x) {
                        this[_invoiceDetailId] = x;
                        delete this[_errs].invoiceDetailId;
                    } else {
                        this[_errs].invoiceDetailId = "invoiceDetailId must be a valid integer";
                    }
                },
                get: function () {
                    return this[_invoiceDetailId];
                }
            },

            tankId: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseInt(value, 10);
                    if (x) {
                        this[_tankId] = x;
                        delete this[_errs].tankId;
                    } else {
                        this[_errs].tankId = "tankId must be a valid integer";
                    }

                },
                get: function () {
                    return this[_tankId];
                }
            },

            quantity: {
                enumerable: true,
                configurable: true,
                set: function (value) {


                    if (parseFloat(value) && parseFloat(this.remaining)) {
                        if (value <= (this.remaining / 1000)) {
                            this[_quantity] = parseFloat(value);
                            delete this[_errs].quantity;
                        } else {
                            this[_errs].quantity = "StockIn Quantity not more then Remaining Quantity";
                        }

                    } else {
                        this[_errs].quantity = "quantity must be a valid integer";
                    }
                },
                get: function () {
                    return this[_quantity];
                }
            },
            shiftId: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseInt(value, 10);
                    if (x) {
                        this[_shiftId] = x || null;
                        delete this[_errs].shiftId;
                    } else {
                        this[_errs].shiftId = "ShiftId must be a valid integer";
                    }
                },
                get: function () {
                    return this[_shiftId];
                }
            },
            productId: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseInt(value, 10);
                    if (x) {
                        this[_productId] = x;
                        delete this[_errs].productId;
                    } else {
                        this[_errs].productId = "productId must be a valid integer";
                    }
                },
                get: function () {
                    return this[_productId];
                }
            },
            startDip: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseFloat(value);
                    if (x >= 0) {
                        this[_startDip] = x;
                        delete this[_errs].startDip;
                    } else {
                        this[_errs].startDip = "Start Dip must be a valid integer";
                    }
                },
                get: function () {
                    return this[_startDip];
                }
            },
            endDip: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseFloat(value);
                    if (x) {
                        this[_endDip] = x;
                        delete this[_errs].endDip;
                    } else {
                        this[_errs].endDip = "End Dip must be a valid integer";
                    }
                },
                get: function () {
                    return this[_endDip];
                }
            },
            startDipVolume: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseFloat(value);

                    this[_startDipVolume] = x || null;

                },
                get: function () {
                    return this[_startDipVolume];
                }
            },
            endDipVolume: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseFloat(value);

                    this[_endDipVolume] = x || null;

                },
                get: function () {
                    return this[_endDipVolume];
                }
            },

            beforeReading: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseFloat(value);
                    if (x) {
                        this[_beforeReding] = x;
                        delete this[_errs].beforeReading;
                    } else {
                        this[_errs].beforeReading = "Before Reding   must be a valid integer";
                    }
                },
                get: function () {
                    return this[_beforeReding];
                }
            },
            afterReading: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseFloat(value);
                    if (x) {
                        this[_afterReading] = x;
                        delete this[_errs].afterReading;
                    } else {
                        this[_errs].afterReading = "After Reading  must be a valid integer";
                    }
                },
                get: function () {
                    return this[_afterReading];
                }
            },
            stockInId: {
                enumerable: true,
                configurable: true,
                set: function (value = 0) {
                    this[_stockInId] = value;
                },
                get: function () {
                    return this[_stockInId];
                }
            },


        });
        this.shiftDate = shiftDate;
        this.invoiceDetailId = invoiceDetailId;
        this.tankId = tankId;
        this.quantity = quantity;
        this.shiftId = shiftId;
        this.stockInId = stockInId;
        this.stockInDateTime = stockInDateTime;
        this.productId = productId;
        this.remaining = remaining;
        this.startDip = startDip;
        this.endDip = endDip;
        this.beforeReading = beforeReading;
        this.afterReading = afterReading;
        this.startDipVolume = startDipVolume;
        this.endDipVolume = endDipVolume;
    }

    hasError() {
        return Object.keys(this[_errs]).length > 0;
    }

    getErrors() {
        return this[_errs];
    }

    // checkQuantity(quantity) {
    //     if (parseFloat(quantity) && this.remaining >= quantity) {
    //         this.quantity = quantity;
    //     } else {
    //         this[_errs].quantity = "StockIn Quantity not more then Remaining Quantity";
    //     }
    // }

    checkReding(beforeReading, afterReading) {
        if (beforeReading > afterReading) {
            this[_errs].afterReading = "After Reading  must be greater than Before Reading ";
        } else {
            delete this[_errs].afterReading;
        }
    }
    checkAtg(startDipVolume, endDipVolume, isAtg) {
        console.log(isAtg);
        if (isAtg) {
            if (startDipVolume && endDipVolume) {
                if (startDipVolume > endDipVolume) {
                    this[_errs].endDipVolume = "End Volume must be greater than start Volume";
                } else {
                    delete this[_errs].startDipVolume;
                    delete this[_errs].endDipVolume;
                }
            } else {
                !startDipVolume ? this[_errs].startDipVolume = "Start Volume must be a valid integer" :
                    this[_errs].endDipVolume = "End Volume must be a valid integer";
            }
        } else {
            delete this[_errs].startDipVolume;
            delete this[_errs].endDipVolume;
        }
    }

    checkDip(startDip, endDip) {
        if (startDip > endDip) {
            this[_errs].endDip = "End dip must be greater than start dip";
        } else {
            delete this[_errs].endDip;
        }
    }
}
module.exports = StockIn;


// WEBPACK FOOTER //
// ./src/models/backward-stockin.js